var styleDataHash = "62a7e6a6";
const injectCss = () => {
  var css = `.ILfVH,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.CPDD8{align-items:center;color:var(--wds-color-text-standard-primary,var(--wsr-color-D10,#000624));display:flex;min-height:36px;padding-block:var(--ricos-internal-list-item-select-padding-block,6px);padding-inline:var(--ricos-internal-list-item-select-padding-inline,18px);--wds-color-text-standard-secondary:var(
    --wds-list-item-select-subtitle,var(--wsr-color-D40,#868aa5)
  )}[dir] .CPDD8{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));cursor:pointer}[dir] .CPDD8:hover{background-color:var(--wds-list-item-select-fill-hover,var(--wsr-color-B50,#e7f0ff))}.CPDD8.M5LLZ,.CPDD8:active{--wds-color-text-standard-primary:var(
    --wds-list-item-select-active-title,var(--wsr-color-D80,#fff)
  );--wds-color-text-standard-secondary:var(
    --wds-list-item-select-active-subtitle,var(--wsr-color-D80,#fff)
  )}[dir] .CPDD8.M5LLZ,[dir] .CPDD8:active{background-color:var(--wds-list-item-select-active-fill,var(--wsr-color-B10,#116dff))}[dir] .CPDD8.M5LLZ:hover{background-color:var(--wds-list-item-select-active-fill-hover,var(--wsr-color-B20,#5999ff))}.CPDD8.cIXSx{color:var(--wds-list-item-select-title-disabled,var(--wsr-color-D10-30,rgba(0,6,36,.3)));pointer-events:none}[dir] .CPDD8.cIXSx{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));cursor:auto}.CPDD8:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.CPDD8.rpyHS{--wds-font-size-body-medium:16px}.CPDD8.oRMxi{min-height:54px}.kHeVB{column-gap:6px;display:grid;flex:1;grid-template-areas:"prefix title suffix";grid-template-columns:max-content 1fr max-content;grid-template-rows:auto auto}.oRMxi{grid-template-areas:"prefix title suffix" "prefix subtitle suffix"}.Zpchr{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:prefix}.hkP7w{align-self:center;grid-area:title}.a5lZK,.hkP7w{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.a5lZK{grid-area:subtitle}.l9-r-{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:suffix}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "ILfVH",
  "root": "CPDD8",
  "selected": "M5LLZ",
  "disabled": "cIXSx",
  "mobile": "rpyHS",
  "withSubtitle": "oRMxi",
  "content": "kHeVB",
  "prefix": "Zpchr",
  "title": "hkP7w",
  "subtitle": "a5lZK",
  "suffix": "l9-r-"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
